import { Box, Paper, Typography } from '@mui/material';

import type { AcademyLesson } from '../../../pages/academy/Academy/AcademyService';
import { CheckIcon } from '../AcademyStatus/AcademyStatus';
import {
  appliedActionsSummaryClassNames,
  appliedActionsSummaryStyles,
} from './AppliedActionsSummary.styles';

export interface AppliedActionsSummaryProps {
  skill: AcademyLesson;
}

export function AppliedActionsSummary({ skill }: AppliedActionsSummaryProps) {
  if (skill.confirmationPolicy === 'user_full_confirm') {
    return null;
  }

  const actions = getAppliedActions(skill);

  return (
    <Paper
      className={appliedActionsSummaryClassNames.root}
      elevation={0}
      sx={appliedActionsSummaryStyles.root()}
    >
      <Box
        component="span"
        className={appliedActionsSummaryClassNames.icon}
        sx={appliedActionsSummaryStyles.icon()}
        aria-hidden="true"
      >
        <CheckIcon />
      </Box>
      <Box>
        <Typography component="h4" sx={appliedActionsSummaryStyles.title()}>
          We show the following completed actions:
        </Typography>
        <Box component="ol" sx={appliedActionsSummaryStyles.list()}>
          {actions.map((action, index) => (
            <li key={index}>{action}</li>
          ))}
        </Box>
      </Box>
    </Paper>
  );
}

function getAppliedActions(skill: AcademyLesson): string[] {
  if (skill.appliedActions && skill.appliedActions.length > 0) {
    return skill.appliedActions;
  }

  if (skill.selfReportPrompt) {
    return [skill.selfReportPrompt];
  }

  return [skill.description || 'Completed classroom action'];
}
